module.exports = __webpack_public_path__ + "img/music_011.042caee3.png";